export const eTipoUsuario = {
    Vendedor: 1,
    Master: 2,
    MotoristaVendedor: 3
}